<section class="container-wrapper">
    <h1 class="module-heading">{{ 'pages.config-all.config-colour.heading' | translate }}</h1>
    <div class="loading-spinner" *ngIf="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="20">
      </mat-progress-spinner>
    </div>
    <div *ngIf="!loading" [formGroup]="colourConfigForm">
      <section>
        <h2>{{ 'pages.config-all.config-colour.background' | translate }}</h2>
        <app-color-picker [colorForm]="colourConfigForm" formName="background"></app-color-picker>
      </section>

      <section>
        <h2>{{ 'pages.config-all.config-colour.icon' | translate }}</h2>
        <app-color-picker [colorForm]="colourConfigForm" formName="icon"></app-color-picker>
      </section>

      <section>
        <h2>{{ 'pages.config-all.config-colour.text' | translate }}</h2>
        <app-color-picker [colorForm]="colourConfigForm" formName="text"></app-color-picker>
      </section>

      <section>
        <h2>{{ 'pages.config-all.config-colour.name' | translate }}</h2>
        <app-color-picker [colorForm]="colourConfigForm" formName="name"></app-color-picker>
      </section>

      <section>
        <h2>{{ 'pages.config-all.config-colour.menu' | translate }}</h2>
        <app-color-picker [colorForm]="colourConfigForm" formName="menu"></app-color-picker>
      </section>

      <div>
        <!-- header.component.html -->
        <h2>{{ 'pages.config-all.config-colour.preview' | translate }}</h2>

        <header class="header" [ngStyle]="getToolbarStyle()">
          <div class="header-content" [ngStyle]="getToolbarStyle()">
            <!-- Mobile Menu Icon-->
            <button 
                class="menu-toggle-button" 
            >
                <span class="icon-menu" [ngStyle]="getMenuStyle()"></span>
            </button>
            <!-- Logo and City Name -->
            <div class="logo-section">
              <img *ngIf="!org.logo" src="https://bcitiliteassets.blob.core.windows.net/images/bciti/bciti-smart-logo.png" alt="Brossard logo" class="logo">
              <img *ngIf="org.logo" [src]="org.logo" alt="Brossard logo" class="logo">
              <div class="city-select">
                <span class="city-name" [ngStyle]="getNameStyle()">{{ org.name }}</span>
                <span class="chevron" [ngStyle]="getNameStyle()">▼</span>
              </div>
            </div>
            
            <!-- Right Section with Language and Bell -->
            <div class="right-section">
              <!-- Language Toggle -->
              <div class="language-toggle" [ngStyle]="getTextStyle()">
                <span>
                    <button class="bciti-link" [ngStyle]="getTextStyle()" >{{ currLang }}</button>
                </span>
              </div>
        
              <!-- Notification Bell -->
              <div class="notification-bell">
                <div class="bell-icon">
                  <mat-icon 
                    class="notification-widget icon-notifications" 
                    [matBadge]="0"
                    [ngStyle]="getIconStyle()"
                    matBadgeColor="warn"
                    matBadgeSize="small"
                    matBadgePosition="after"
                    matTooltip="{{ 'components.notification-widget.viewNotifications' | translate }}"
                    matTooltipPosition="left">
                  </mat-icon>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
      <div class="row justify-end">
        
        <button 
          class="bciti-button" 
          [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--red'"
          [disabled]="processingSubmit"
          (click)="cancel()"
        >
          <span>{{ 'pages.config-all.config-requests.button.cancel' | translate }}</span>
        </button>
        <button 
          class="bciti-button ml-10" 
          [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue-inversed'"
          [disabled]="processingSubmit"
          (click)="setDefault()"
        >
          <span>{{ 'pages.config-all.config-requests.button.default' | translate }}</span>
        </button>
        <button 
          class="bciti-button ml-10" 
          [ngClass]="!validateForm() || processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue'"
          [disabled]="!validateForm() || processingSubmit"
          (click)="submit()"
        >
          <span class="submit-loader">
            {{ 'pages.config-all.config-requests.button.submit' | translate }} 
            <mat-spinner *ngIf="processingSubmit"
              diameter="20" 
            ></mat-spinner>
          </span>
        </button>
      </div>
    </div>
  </section>